import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { PerNgPlatformService } from '@pershing/per-ng-platform-service';
import { PageService } from '../services/page.service';
import { AuthService } from '../services/auth.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private _pageService: PageService,
    private _platformService: PerNgPlatformService,
    private authService: AuthService,
    private _router: Router
  ) {}

  async canActivateChild(
    activeRoute: ActivatedRouteSnapshot
  ): Promise<boolean> {
    return await this.canActivate(activeRoute);
  }

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    let page: string =
      route.url.length === 1
        ? route.url[0].path
        : route.url[route.url.length - 1].path;
    if (
      this._pageService.isPagePublic(page) ||
      this._platformService.isUserLoggedIn()
    ) {
      this.authService
        .invokeAsyncKeepAlive()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe();
      return true;
    } else {
      this._router.navigate(['/login']);
      return false;
    }
  }
}
